import { n as delete1, t as meta1 } from "./meta1.js";
import { mutationOptions, useMutation } from "@tanstack/react-query";
//#region src/__generated__/files/final-decision-document/hooks/useDelete1.ts
const delete1MutationKey = () => [{ url: "/api/mdm/internal/files/api/final-decision-document/delete" }];
function delete1MutationOptions(config = {}) {
	const mutationKey = delete1MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await delete1({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* {@link /api/mdm/internal/files/api/final-decision-document/delete}
*/
function useDelete1(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? delete1MutationKey();
	const baseOptions = delete1MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/files/final-decision-document/hooks/useMeta1.ts
const meta1MutationKey = () => [{ url: "/api/mdm/internal/files/api/final-decision-document/meta" }];
function meta1MutationOptions(config = {}) {
	const mutationKey = meta1MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await meta1({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* {@link /api/mdm/internal/files/api/final-decision-document/meta}
*/
function useMeta1(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? meta1MutationKey();
	const baseOptions = meta1MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { delete1MutationOptions as a, delete1MutationKey as i, meta1MutationOptions as n, useDelete1 as o, useMeta1 as r, meta1MutationKey as t };

//# sourceMappingURL=useMeta1.js.map